module.exports = __webpack_public_path__ + "static/img/login.316a8596.jpg";